import { GeoOverrideHeader } from 'src/common/enums';
import type { ApiResponse, PostErrorResponse, QueryErrorResponse } from 'src/common/interfaces';

export const hasResponseData = <T>(obj: unknown): obj is { data: ApiResponse<T> } =>
  typeof obj === 'object' && !!obj && 'data' in obj && !!(obj as ApiResponse<T>)?.data && !('error' in obj);

export const hasErrorPostData = (obj: unknown): obj is PostErrorResponse =>
  typeof obj === 'object' && !!obj && 'error' in obj && isQueryErrorWithMessage(obj?.error);

export const isQueryErrorWithMessage = (error: unknown): error is QueryErrorResponse =>
  typeof error === 'object' &&
  error != null &&
  'data' in error &&
  typeof (error as QueryErrorResponse).data.message === 'string';

export const getGeoOverrideHeaders = (): Record<GeoOverrideHeader, string> => {
  const overrides = Object.values(GeoOverrideHeader)
    .map((header) => {
      const value = sessionStorage.getItem(header);
      return value ? [header, value] : null;
    })
    .filter(Boolean) as [GeoOverrideHeader, string][];

  return Object.fromEntries(overrides) as Record<GeoOverrideHeader, string>;
};
